<template>
    <div class="box">
        <h1 class="title">Post Management</h1>

        <div class="columns">
            <div class="column is-half">
                <section>
                    <b-menu class="">
                        <b-menu-list label="Main Categories">
                            <b-menu-item
                                :key="cat.id"
                                v-for="cat in cats"
                                @click="subs = cat.categories"
                                icon="folder"
                                :label="cat.name"
                            ></b-menu-item>
                        </b-menu-list>
                    </b-menu>
                </section>
            </div>
            <div class="column is-half">
                <b-menu class="">
                    <b-menu-list label="Categories">
                        <b-menu-item disabled label="No available categories" v-if="cats.length == 0" />
                        <b-menu-item :key="c.id" :label="c.name" @click="routeTo(c)" icon="folder" v-for="c in subs"></b-menu-item>
                    </b-menu-list>
                </b-menu>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            cats: [],
            lang: null,
            subs: [],
        };
    },
    methods: {
        routeTo(cat) {
            // if (cat.id == 6) {
            //     // Our Story
            //     this.$router.push(`/home/posts/our-story`);
            //     return;
            // }
            this.$router.push(`/home/posts/${cat.id}`);
        },
        async init() {
            try {
                let res = await this.$http.get("/posts/cats/all");
                this.cats = res.data;
            } catch (err) {
                this.swal.fire("Error!", "There were something wrong." + err, "warning");
            }
        },
    },
    computed: {
        filteredDataArray() {
            if (this.cats.length == 0) {
                return [];
            }
            return this.cats.filter((option) => {
                return option.clickable == 1 && option.lang == this.lang;
            });
        },
    },
    mounted() {
        this.init();
    },
};
</script>